import { Box, Container, Flex, Grid, GridItem, Image, Stack, Text } from "@chakra-ui/react";
import Head from "next/head";
import { useState } from "react";

import Footer from "@/sections/home/Footer";
import Header from "@/sections/home/Header";

const cards = [
    {
        title: "Mentor Fase 1",
        text: "Habilitar a Desarrollo Humano para poder utilizar su plataforma de eLearning.",
        icon: "https://media.grupoguia.mx/assets/home-page/tech/cards/mentor.svg",
        bg: "linear-gradient(180deg, #000000 0%, #646464 100%)",
        color: "white",
    },
    {
        title: "Landing Nosotros",
        text: "Mejora continua de nuestro sitio, herramientas y curriculum. En 2023 agregamos secciones (como esta) que nos permiten compartir el valor de Grupo Guía para que las personas vivan mejor.",
        icon: "https://media.grupoguia.mx/assets/home-page/tech/cards/nosotros.svg",
        bg: "linear-gradient(180deg, #07446F 0%, #0961B3 100%)",
        color: "white",
    },
    {
        title: "Secciones Retail & Industrial",
        text: "Estamos estrenando plataforma tecnológica y automatizando cada día más el proceso de nuevos productos como las secciones industrial y de usos comerciales.",
        icon: "https://media.grupoguia.mx/assets/home-page/tech/cards/industrialyretail.svg",
        bg: "linear-gradient(180deg, #192B4A 0%, #112C5B 100%)",
        color: "white",
    },
    {
        title: "Landing disponibilidad",
        text: "Nuestros clientes siempre son primero, gracias a nuestra plataforma propietaria podemos extender nuestras herramientas, disponibilidad e inventario a otros sitios de manera rápida y segura.",
        icon: "https://media.grupoguia.mx/assets/home-page/tech/cards/disponibility.svg",
        bg: "linear-gradient(180deg, #F9F9F9 0%, #D1D1D1 100%)",
        color: "black",
    },
    {
        title: "Venta en línea",
        text: "La venta en línea además de ponernos a la vanguardia, nos ayuda a tener un proceso eficiente y una experiencia de compra agradable. ",
        icon: "https://media.grupoguia.mx/assets/home-page/tech/cards/onlinesale.svg",
        bg: "linear-gradient(180deg, #4E0F9A 0%, #240A44 100%)",
        color: "white",
    },
    {
        title: "Migración Kubernetes (app nativa Cloud)",
        text: "Nuestra nueva infraestructura nativa en la nube nos permite tener escalabilidad, resilencia y tolerancia a fallos, además de un sistema de monitoreo y alertas de las aplicaciones críticas para estar siempre disponibles para ti.",
        icon: "https://media.grupoguia.mx/assets/home-page/tech/cards/k8s.svg",
        bg: "linear-gradient(180deg, #000000 0%, #646464 100%)",
        color: "white",
    },
    {
        title: "Vision",
        text: 'Nuestros asesores en inversión cuentan con la plataforma original "Vision", diseñada especialmente para poner los 50 años de experiencia que nos respaldan a disposición de nuestro talento, desde el día uno.',
        icon: "https://media.grupoguia.mx/assets/home-page/tech/cards/vision.svg",
        bg: "linear-gradient(180deg, #000000 0%, #646464 100%)",
        color: "white",
    },
    {
        title: "Inventario",
        text: "Rediseñamos nuestro sistema de inventario, con capacidades difícilmente igualables en el mercado méxicano.",
        icon: "https://media.grupoguia.mx/assets/home-page/tech/cards/inventory.svg",
        bg: "linear-gradient(180deg, #07446F 0%, #0961B3 100%)",
        color: "white",
    },
    {
        title: "Cotizador",
        text: "Nuestro cotizador hecho a la medida enfocado en el cliente, hace más sencillo tomar decisiones de compra, ahorrando ciclos de preguntas y confusión, ya que aplicamos nuestra basta experiencia para hacerlo sencillo y eficiente.",
        icon: "https://media.grupoguia.mx/assets/home-page/tech/cards/quoter.svg",
        bg: "linear-gradient(180deg, #192B4A 0%, #112C5B 100%)",
        color: "white",
    },
    {
        title: "Chatbots",
        text: "Este año liberamos chatbots basados en Inteligencia artificial y continuaremos innovando para encontrar la combinación exacta humano-máquina.",
        icon: "https://media.grupoguia.mx/assets/home-page/tech/cards/Chat_bot.svg",
        bg: "linear-gradient(180deg, #4E0F9A 0%, #240A44 100%)",
        color: "white",
    },
    {
        title: "Migración a correos Microsoft 365",
        text: "En 2023 terminamos la migración de todos los integrantes de la familia Guía a Microsoft 365, lo que potencializa nuestra capacidad de entregar aplicaciones de calidad mundial y ayuda a toda la organización a trabajar con eficiencia y dinamismo.",
        icon: "https://media.grupoguia.mx/assets/home-page/tech/cards/Microsoft_365.svg",
        bg: "linear-gradient(180deg, #F9F9F9 0%, #D1D1D1 100%)",
        color: "black",
    },
    {
        title: "Creador de landings",
        text: 'Con nuestro "landing creator", somos capaces de crear landings para desarrollos con todo el expertise que hemos logrado durante 50 años en el giro inmobiliario. Todas optimizadas en SEO y con las mejores prácticas.',
        icon: "https://media.grupoguia.mx/assets/home-page/tech/cards/landingcreator.svg",
        bg: "linear-gradient(180deg, #000000 0%, #646464 100%)",
        color: "white",
    },
    {
        title: "Mapas interactivos Kulkana",
        text: "Desarrollamos herramientas que nos permiten vectorizar mapas de terrenos mucho más rápido que la competencia, además la misma herramienta esta integrada con nuestro inventario, por lo que el tiempo de espera para lanzar un producto a la venta se reduce drásticamente.",
        icon: "https://media.grupoguia.mx/assets/home-page/tech/cards/mapainteractivo.svg",
        bg: "linear-gradient(180deg, #000000 0%, #646464 100%)",
        color: "white",
    },
    {
        title: "Soporte",
        text: "Implementamos un sistema de soporte que nos ayuda a medir en tiempo real, la satisfacción de nuestro equipo para que siempre estén a la vanguardia con las mejores herramientas y te ayuden a vivir mejor.",
        icon: "https://media.grupoguia.mx/assets/home-page/tech/cards/support.svg",
        bg: "linear-gradient(180deg, #07446F 0%, #0961B3 100%)",
        color: "white",
    },
];

export default function Tech() {
    const [selected, setSelected] = useState("Mision");

    return (
        <>
            <Head>
                <title>Tech | Grupo Guía</title>
                <link rel="canonical" href="https://grupoguia.mx/tech" />
                <link rel="alternate" href="https://grupoguia.mx/tech" hrefLang="es-mx" />
            </Head>
            <Header />
            <Container maxW="full" p={0}>
                <Box w="full" mx="auto" paddingInline="0">
                    <Flex
                        w="100%"
                        h="70vh"
                        id="fondo"
                        backgroundImage="url(https://media.grupoguia.mx/assets/home-page/tech/Hero.webp)"
                        backgroundSize="cover"
                        backgroundPosition="center center"
                        backgroundRepeat="no-repeat"
                        position="relative"
                        p="0"
                        bgColor="gray.100"
                    >
                        <Flex direction="column" w="100%" position="absolute" left="0" top="38%">
                            <Stack
                                mt={15}
                                direction={{ base: "column", md: "row" }}
                                w="full"
                                maxW="6xl"
                                mx="auto"
                                align="center"
                                transitionDuration=".3s"
                                justifyContent="center"
                            >
                                <Box>
                                    <Image
                                        src="https://media.grupoguia.mx/assets/home-page/tech/logo.svg"
                                        h="20"
                                        w="auto"
                                        alt="simple icon"
                                    />
                                    <Text
                                        color="#FFFFFF"
                                        fontWeight="600"
                                        fontSize={{ base: "lg", sm: "2xl" }}
                                        textAlign="center"
                                    >
                                        Para habilitar y servir
                                    </Text>
                                </Box>
                            </Stack>
                        </Flex>
                    </Flex>
                </Box>
            </Container>
            <Container maxW="100vw" px={6}>
                <Box my={20}>
                    <Grid
                        templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(2, 1fr)" }}
                        gap={6}
                    >
                        <GridItem colSpan={1} display={{ base: "none", md: "block" }}>
                            <Image
                                src="https://media.grupoguia.mx/assets/home-page/tech/misionvision.svg"
                                maxW="80%"
                                h="auto"
                                alt="simple icon"
                            />
                        </GridItem>
                        <GridItem colSpan={1}>
                            <Stack>
                                <Flex alignSelf={{ base: "center", md: "flex-start" }}>
                                    <Text
                                        color="#000000"
                                        fontWeight={selected === "Mision" ? "700" : "500"}
                                        fontSize={{ base: "2xl", sm: "3xl" }}
                                        align="left"
                                        pr={4}
                                        borderBottom={
                                            selected === "Mision"
                                                ? "4px solid #4E4E4E"
                                                : "2px solid #ABABAB"
                                        }
                                        onClick={() => setSelected("Mision")}
                                        cursor="pointer"
                                    >
                                        Misión
                                    </Text>
                                    <Text
                                        color="#000000"
                                        fontWeight={selected === "Vision" ? "700" : "500"}
                                        fontSize={{ base: "2xl", sm: "3xl" }}
                                        align="left"
                                        borderBottom={
                                            selected === "Vision"
                                                ? "4px solid #4E4E4E"
                                                : "2px solid #ABABAB"
                                        }
                                        onClick={() => setSelected("Vision")}
                                        px={6}
                                        cursor="pointer"
                                    >
                                        Visión
                                    </Text>
                                </Flex>
                            </Stack>
                            <Stack mb={4} mt={6}>
                                {selected === "Mision" ? (
                                    <Text fontSize={{ base: "lg", sm: "xl" }} fontWeight="400">
                                        Potenciar el crecimiento 10x y el éxito de Grupo Guía a
                                        través de la tecnología y el enfoque orientado a datos. 
                                        <br />
                                        <br />
                                        Nuestra misión es construir y mantener una infraestructura
                                        tecnológica de vanguardia que permita la toma de decisiones
                                        informadas, la optimización de procesos y la entrega de
                                        servicios de alta calidad a nuestros clientes.
                                        <br />
                                        <br />
                                        Habilitar la innovación tecnológica y el éxito de todas las
                                        áreas de Grupo Guía a través de la tecnología para que
                                        nuestros clientes vivan mejor.
                                    </Text>
                                ) : (
                                    <Text fontSize={{ base: "lg", sm: "xl" }} fontWeight="400">
                                        Ser el equipo de alto desempeño de IT líder en la industria
                                        inmobiliaria de latinoamérica.
                                        <br />
                                        <br />
                                        Reconocido por nuestra capacidad para gobernar y transformar
                                        datos en insights estratégicos y soluciones innovadoras. 
                                        <br />
                                        <br />
                                        Nuestra visión es impulsar a Grupo Guía hacia un futuro
                                        donde cada decisión esté respaldada por datos sólidos y
                                        donde seamos pioneros en la aplicación de tecnología
                                        avanzada para mejorar la experiencia del cliente y el
                                        crecimiento sostenible de la empresa en nuevos mercados.
                                    </Text>
                                )}
                            </Stack>
                        </GridItem>
                        <GridItem
                            colSpan={1}
                            display={{ base: "flex", md: "none" }}
                            justifyContent="center"
                        >
                            <Image
                                src="https://media.grupoguia.mx/assets/home-page/tech/misionvision.svg"
                                maxW="80%"
                                h="auto"
                                alt="simple icon"
                            />
                        </GridItem>
                    </Grid>
                </Box>
                <Box my={20}>
                    <Stack mt={4} mb={8}>
                        <Text
                            fontSize={{ base: "2xl", sm: "3xl" }}
                            fontWeight="600"
                            textAlign="center"
                            color="#002B49"
                        >
                            Nuestros proyectos
                        </Text>
                    </Stack>
                    <Grid
                        templateColumns={{
                            base: "repeat(1, 1fr)",
                            md: "repeat(2, 1fr)",
                            lg: "repeat(3, 1fr)",
                        }}
                        gap={8}
                    >
                        {cards.map((card, index) => (
                            <GridItem key={index} colSpan={1}>
                                <Box
                                    bg={card.bg}
                                    px={6}
                                    py={10}
                                    rounded="2xl"
                                    h="full"
                                    textAlign="center"
                                >
                                    <Stack h="100%" justifyContent="space-between">
                                        <Text
                                            color={card.color}
                                            fontWeight="600"
                                            fontSize={{ base: "lg", sm: "2xl" }}
                                            align="center"
                                        >
                                            {card.title}
                                        </Text>
                                        <Text
                                            color={card.color}
                                            fontSize={{ base: "sm", sm: "md" }}
                                            align="center"
                                        >
                                            {card.text}
                                        </Text>
                                        <Image
                                            src={card.icon}
                                            w="auto"
                                            h="250px"
                                            objectFit="contain"
                                            alt="simple icon"
                                        />
                                    </Stack>
                                </Box>
                            </GridItem>
                        ))}
                    </Grid>
                </Box>
                <Box my={20} display={{ base: "none", md: "block" }}>
                    <Stack>
                        <Text
                            fontSize={{ base: "lg", sm: "xl" }}
                            color="#002B49"
                            textAlign="center"
                            fontWeight="400"
                        >
                            Estas son solo algunas de las razones por las cuales deberías elegir a
                            Grupo Guía
                        </Text>
                        <Text
                            fontSize={{ base: "xl", sm: "2xl" }}
                            color="#002B49"
                            textAlign="center"
                            fontWeight="700"
                        >
                            para realizar tus operaciones inmobiliarias. Guía es el lugar para ti.
                        </Text>
                    </Stack>
                    <Stack mt={20}>
                        <Flex justifyContent="center" alignItems="center" gap={10}>
                            <Image
                                src="https://media.grupoguia.mx/assets/home-page/tech/end.svg"
                                w="350px"
                                h="auto"
                                alt="simple icon"
                            />
                            <Box maxW={{ base: "100%", md: "30%" }}>
                                <Text textAlign="center">
                                    Desarrollo ágil, nuestra meta es entregar valor lo antes
                                    posible, para que las personas vivan mejor.
                                    <br />
                                    <br />
                                    100% satisfecho, para garantizarlo nuestros proyectos solo se
                                    cierran cuando el cliente queda 100% satisfecho
                                </Text>
                            </Box>
                        </Flex>
                    </Stack>
                </Box>
            </Container>
            <Footer esGuiaRent={false} />
        </>
    );
}
